package com.patronat.top.features.venues.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueListResponse
import com.patronat.top.features.venues.domain.repository.VenuesRepository
import com.patronat.top.features.venues.domain.usecase.command.GetFilteredVenuesCommand

class GetFilteredVenuesUseCase(
    private val venuesRepository: VenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetFilteredVenuesCommand, DomainResult<VenueListResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetFilteredVenuesCommand): DomainResult<VenueListResponse> {
        return venuesRepository.getFilteredVenues(command.filter)
    }
}
